import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { SpeechProvider } from "@speechly/react-client";
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './Home';
import Header from './Component/Header/Header';
import Register from './Pages/Form';
import LectureCard from './Pages/Home';
import LandingPage from './Pages/LandingPage';
import Voiceinput from './Pages/Voiceform';
import Chatgpt from './Pages/chatgpt';
import QueryPage from './Pages/queriespage/queriesPage';
import VoiceinputGpt from './Pages/VoiceInputGpt';
import LoginPage from './Pages/LoginPage.jsx';
import AddQuery from './Pages/AddQuery.jsx';
import Footer from './Component/Header/Footer';

const root = ReactDOM.createRoot(document.getElementById('root'));

const MainApp  = () =>{
  const [isAdminPage,setAdminPage] = React.useState(false);
  const [langCode, setLangCode] = React.useState();
  const history = useLocation();

   React.useEffect(() => {
    if(history.pathname == '/govtofindiascheme/add-query'){
      setAdminPage(true)
    }
    else{
      setAdminPage(false)
    }
  }, [history.pathname]);

  return(
    <>
      <Header isAdminPage={isAdminPage} langCodeDrop={langCode}/>
          <Routes>
            <Route path='/govtofindiascheme/' element={<LandingPage />} />
            <Route path='/govtofindiascheme/Voiceinput' element={<Voiceinput />} />
            <Route path='/govtofindiascheme/chatgpt' element={<Chatgpt />} />
            <Route path='/govtofindiascheme/Recent-queries' element={<QueryPage />} />
            <Route path='/govtofindiascheme/Selected-query' element={<VoiceinputGpt />} />
            {/* <Route path='/govtofindiascheme/login' element={<LoginPage />} />
            <Route path='/govtofindiascheme/add-query' element={<AddQuery langCode={langCode} setLangCode={setLangCode}/>} /> */}
          </Routes>
          <Footer/>
    </>
  )
}

root.render(
  <React.StrictMode>
    <DndProvider backend={HTML5Backend}>
      <SpeechProvider appId="3d10e555-cd05-49ea-b045-a22b79b27696">
        <Router>
          <MainApp/>
        </Router>
        {/* <App /> */}
      </SpeechProvider>
    </DndProvider>
  </React.StrictMode>
);

reportWebVitals();
